module.exports = __webpack_public_path__ + "img/banner-poland-1-768x225.bb20151a.png";